import './App.css';

import HeaderForm from './components/HeaderForm';
import Navbar from './components/NavBar';
import Header from './components/Header';
import Footer from './components/Footer';
import Masters from './components/Masters';
import FAQ from './components/FAQ';
import Financing from './components/Financing';
import Benefits from './components/Benefits';
import FloatingSidebar from './components/FloatingSidebar';
import Information from './components/Information';
import FooterNew from './components/FooterNew';

function App() {
	return (
		<div className='App'>
			<Navbar />
			<HeaderForm />
			{/* <FloatingSidebar /> */}
			{/* <Header /> */}
			<Masters />
			<Information />
			<Benefits />
			<Financing />
			<FAQ />
			<FooterNew />
			{/* <Footer /> */}
		</div>
	);
}

export default App;
